import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { GatingServices } from '../modules/core/services/gating.services';
import * as fromRoot from '../reducers';
import * as olci from '../actions/olci';

export const governanceContentResolver: ResolveFn<any> = (): Observable<boolean> => {
	const gatingService: GatingServices = inject(GatingServices);
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const olciDataCookie = gatingService.getOlciDataCookie();
	store.dispatch(new olci.FetchGovernanceContent({ shipCode: olciDataCookie.shipCode, sailDate: olciDataCookie.sailDate }));
	return of(true);
}